/* eslint-disable import/prefer-default-export */
import api from 'core/api';

export const recurring = (id, workoutId, page, perPage) =>
  api.get(`/recurrings/${id}?workoutId=workout_id=${workoutId}&page=${page}&per_page${perPage}`);
export const recurringsByChannel = (channelId) => api.get(`/recurrings/by_channel/${channelId}`);
export const stopRecurring = (recurringsIds, disable, startAtRemoveWorkouts) =>
  api.post(`/recurrings/stop`, { disable, recurringsIds, startAtRemoveWorkouts });
export const extendRecurring = (data) => api.post(`/recurrings/extend/${data.id}`, data);
